import { Controller } from "@hotwired/stimulus"

// Adds rows to nested_attributes forms.
//
// Markup:
//   <div data-controller="nested-form">
//     <div data-nested-form-target="list">...existing rows...</div>
//     <template data-nested-form-target="template">
//       <!-- row markup with "NEW_RECORD" wherever the index goes -->
//     </template>
//     <button type="button" data-action="nested-form#add">Add</button>
//   </div>
//
// On a row: <button data-action="nested-form#remove">Remove</button>
//          (optionally marks a hidden _destroy field for persisted records)
export default class extends Controller {
  static targets = ["list", "template"]

  add(event) {
    event.preventDefault()
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, Date.now() + Math.floor(Math.random() * 1000))
    this.listTarget.insertAdjacentHTML("beforeend", content)
  }

  remove(event) {
    event.preventDefault()
    const row = event.target.closest("[data-nested-row]")
    if (!row) return

    const destroyField = row.querySelector("input[name$='[_destroy]']")
    if (destroyField) {
      destroyField.value = "1"
      row.style.display = "none"
    } else {
      row.remove()
    }
  }
}
